module.exports = __webpack_public_path__ + "img/trialsAnalytics.da8eff04.png";